var React = require('react');

function IconClose (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#1B1D23","fillRule":"evenodd","d":"M17.425.954l2.12 2.121-7.424 7.425 7.425 7.425-2.121 2.12L10 12.622l-7.425 7.425-2.12-2.121L7.878 10.5.454 3.075 2.575.955 10 8.378 17.425.954z"}));
}

IconClose.defaultProps = {"width":"20","height":"21"};

module.exports = IconClose;

IconClose.default = IconClose;
